"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReanimatedBottomSheetBackdrop = void 0;
const bottom_sheet_1 = require("@gorhom/bottom-sheet");
const react_1 = __importDefault(require("react"));
const backdropStyle = {
    backgroundColor: 'rgba(17, 17, 17, 0.70)',
};
exports.ReanimatedBottomSheetBackdrop = ({ appearsOnIndex = 0, disappearsOnIndex = -1, opacity = 0.5, style = backdropStyle, pressBehavior = 'close', ...restProps }) => {
    return (react_1.default.createElement(bottom_sheet_1.BottomSheetBackdrop, Object.assign({ appearsOnIndex: appearsOnIndex, disappearsOnIndex: disappearsOnIndex, opacity: opacity, style: style, pressBehavior: pressBehavior }, restProps)));
};
